// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + ({"138":"profile","178":"connections","454":"applications","472":"settings","477":"policy","692":"authorized","717":"email","729":"tokens","891":"redirect","966":"login","977":"security"}[chunkId] || chunkId) + ".js";
};